import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TableModel } from 'src/app/models/table.model';
import { environment } from 'src/environments/environment';
import { PagedZohoBookBillDetail } from '../models/paged.zoho.book.bill.detail';

@Injectable()
export class ZohoBookService {

    constructor(private http: HttpClient) { }

    list(tableModel: TableModel): Observable<PagedZohoBookBillDetail> {
        let url = `${environment.apiUrl}/api/admin/zohoBookBill/list`;
        const queryParams = [];
        if (tableModel) {
            queryParams.push(tableModel.toQueryString());
        }
        if (queryParams.length) {
            url += '?' + queryParams.join('&');
        }
        return this.http.get<PagedZohoBookBillDetail>(url);
    }

    details(tableModel: TableModel, id: number): Observable<PagedZohoBookBillDetail> {
        let url = `${environment.apiUrl}/api/admin/zohoBookBill/detail/${id}`;
        const queryParams = [];
        if (tableModel) {
            queryParams.push(tableModel.toQueryString());
        }
        if (queryParams.length) {
            url += '?' + queryParams.join('&');
        }
        return this.http.get<PagedZohoBookBillDetail>(url);
    }
}
